<template>
  <v-data-table class="dashboard__right_stats__invitations_table" :headers="headers" :items="items"
    :pagination.sync="pagination" :loading="loading" :total-items="totalItems" :rows-per-page-text="rowsPerPageText"
    :rows-per-page-items="[10, 25, 50, 100]">
    <template v-slot:progress>
      <v-progress-linear color="blue" indeterminate height="3"></v-progress-linear>
    </template>

    <template v-slot:no-data>
      <v-alert class="empty-alert" type="info" :value="true">
        {{ emptyStateMessage }}
      </v-alert>
    </template>

    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.manager.name }}</td>
      <td class="text-xs-left">{{ props.item.invited_person.name }}</td>
      <td class="text-xs-left">{{ formatToColombiaDate(props.item.created_at) }}</td>
      <td class="text-xs-left">{{ props.item.location.name }}</td>
      <td class="text-xs-left">{{ props.item.invited_type.name }}</td>
      <td class="text-xs-left">{{ props.item.visit_reason.name }}</td>
      <td class="text-xs-left">{{ props.item.additional_description }}</td>
    </template>
  </v-data-table>
</template>

<script>
import { formatToColombiaDate } from '../../lib/helpers';

export default {
  props: {
    items: {
      type: Array,
    },
    totalItems: {
      type: Number,
    },
    currentPage: {
      type: Number,
      default: 1
    },
    rowsPerPage: {
      type: Number,
      default: 10
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ""

    }
  },
  data() {
    return {
      headers: [
        { text: 'Gestor', value: 'manager', sortable: false },
        { text: 'Invitado', value: 'invited_person', sortable: false },
        { text: 'Fecha y hora', value: 'created_at', sortable: false },
        { text: 'Lugar', value: 'location', sortable: false },
        { text: 'Tipo', value: 'invited_type', sortable: false },
        { text: 'Razón de visita', value: 'visit_reason', sortable: false },
        { text: 'Descripción adicional', value: 'additional_description', sortable: false },
      ],
      pagination: {
        page: this.currentPage,
        rowsPerPage: this.rowsPerPage,
        descending: false
      },
      rowsPerPageText: "Filas por página"
    }
  },
  computed: {
    emptyStateMessage() {
      const type = this.getSelectedInvitation.data?.type
      const startDate = this.getStartDate
      const endDate = this.getEndDate
      const stateTranslation = {
        "expired": "Vencidas",
        "pending": "Pendientes",
        "denied": "Denegadas",
        "approved": "Aprobadas",
        "created": "Creadas",
        "cancelled": "Canceladas"
      }

      if (this.getSelectedInvitation.isLoading) {
        return "Cargando datos...";
      }

      if (!type) {
        return "Selecciona un tipo de invitación";
      }

      if (!startDate || !endDate) {
        return `No hay invitaciones ${stateTranslation[type]}`;
      }

      return `No hay invitaciones ${stateTranslation[type]} entre las fechas ${startDate} y ${endDate}`;
    }
  },
  watch: {
    currentPage(newVal) {
      this.pagination.page = newVal;
    },
    pagination: {
      handler(newVal, oldVal) {
        if (oldVal && (newVal.page !== oldVal.page || newVal.rowsPerPage !== oldVal.rowsPerPage)) {
          this.$emit('paginate', {
            page: newVal.page,
            perPage: newVal.rowsPerPage
          });
        }
      },
      deep: true
    }
  },
  methods: {
    formatToColombiaDate
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/stylesheets/utilities/_mixins.scss";

.empty-alert {
  @include empty-alert();
}
</style>